export default {
  autopay: {
    deductionPlanServiceNotice: '如果您想取消自動扣款服務，請聯系客服：+852 3556 3900',
    contactNumber: '【+852 3556 3900】',
  },
}
